'use client';

import { Skeleton } from '@/components/Skeleton';
import { BonusShopGridSkeleton } from './BonusShopGridSkeleton';

interface BonusShopSectionsSkeletonProps {
  sections: number;
}

const TITLE_HEIGHT = 28;
const TITLE_WIDTH = 160;
const CONTROLS_HEIGHT = 32;
const CONTROLS_WIDTH = 140;

export const BonusShopSectionsSkeleton = ({
  sections,
}: BonusShopSectionsSkeletonProps) => (
  <Skeleton.Container flexDirection="column" gap={32}>
    {new Array(sections).fill(0).map((_, index) => (
      <Skeleton.Container flexDirection="column" gap={16} key={index}>
        <Skeleton.Container gap={12} justifyContent="space-between">
          <Skeleton.Rect height={TITLE_HEIGHT} width={TITLE_WIDTH} />
          <Skeleton.Rect height={CONTROLS_HEIGHT} width={CONTROLS_WIDTH} />
        </Skeleton.Container>
        <BonusShopGridSkeleton />
      </Skeleton.Container>
    ))}
  </Skeleton.Container>
);
